import { render, staticRenderFns } from "./transcript-detail-modal.vue?vue&type=template&id=3bf813dd&scoped=true&"
import script from "./transcript-detail-modal.vue?vue&type=script&lang=js&"
export * from "./transcript-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./transcript-detail-modal.vue?vue&type=style&index=0&id=3bf813dd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf813dd",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf813dd')) {
      api.createRecord('3bf813dd', component.options)
    } else {
      api.reload('3bf813dd', component.options)
    }
    module.hot.accept("./transcript-detail-modal.vue?vue&type=template&id=3bf813dd&scoped=true&", function () {
      api.rerender('3bf813dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/modal/transcript-detail-modal/transcript-detail-modal.vue"
export default component.exports